export default {
    inserted(el, bindings, vnode) {
      // 当前按钮传递的值( v-permission="'icon-add'" 中的值)
      // console.log(vnode.context.$route)
      let btns = sessionStorage.getItem('MENU')?JSON.parse(sessionStorage.getItem('MENU')):[]
      let iconcls = bindings.value;
    
      if(btns&&btns.length!=0){
        if (!btns.find((v) => v.menuCode === iconcls)) {
          el.parentNode?.removeChild(el);
        }
      }
    
    },
  };
  